'use client';
import { ListItem } from './list-item.component.js';
import { List } from './list.component.js';
import { OrderedList } from './ordered-list.component.js';

const Ul = List;
const Ol = OrderedList;
const Li = ListItem;

export { Li, List, ListItem, Ol, OrderedList, Ul };
